import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { Icon } from "@iconify/react";

import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

//Store
import { getGameVendorList } from "../../store/ducks/general/actions";
import { postLogOut } from "../../store/ducks/auth/actions";
import { getCountUnreadInboxAlert } from "../../store/ducks/inbox/actions";
import { getFeaturedPromotion } from "../../store/ducks/home/actions";
import { getTopProfile } from "../../store/ducks/profile/actions";
import { postLogin } from "../../store/ducks/auth/actions";
import { getUserData } from "../../store/ducks/currentUser/actions";

// import LoadingPage from "../LoadingPage/LoadingPage";

export class MobileSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSieBar: false,
      login: localStorage.getItem("accessToken") ? true : false,
      loading: false,
      unreadMsgCnt: 0,
      msgLoading: true,
      topProfileData: [],

      deviceOs: "",

    };
  }

  componentDidMount() {
    const savedUsername = localStorage.getItem("username");

    if(savedUsername){
      this.setState({ username: savedUsername });
    }

    if (localStorage.getItem("accessToken")) {
      let params = {};
      params.lang_id = this.props.currentUser.data.language_id;
      this.props.getCountUnreadInboxAlert(params);

      this.sidebarIntervalId = setInterval(() => {
        this.props.getCountUnreadInboxAlert(params);
      }, 10000);
    }
    this.mobileOsDetect();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.logout_data !== this.props.logout_data) {
      if (nextProps.logout_data.responseCode === 200) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("google_user_info");
        sessionStorage.removeItem("google_user_info");
        localStorage.removeItem("showAngbao");
        // localStorage.removeItem('changeCountry');
        // localStorage.removeItem('lang');
        localStorage.removeItem("username");
        localStorage.clear();
        this.setState({
          loading: false,
        });
        window.location.reload();
      } else {
        return false;
      }
    }

    if (nextProps.unreadMessagesCnt !== undefined && nextProps.unreadMessagesCnt !== this.props.unreadMessagesCnt) {
      if (nextProps.unreadMessagesCnt.msgType === "success" && nextProps.unreadMessagesCnt.responseCode === 200) {
        let unreadCnt = nextProps.unreadMessagesCnt.data.totalCount;
        unreadCnt = unreadCnt >= 99 ? 99 : unreadCnt;
        this.setState({
          msgLoading: false,
          unreadMsgCnt: unreadCnt,
        });
      }
    }

    if (nextProps.topProfileData !== undefined && nextProps.topProfileData !== this.props.topProfileData) {
      if (nextProps.topProfileData.responseCode === 200) {
        this.setState({
          topProfileData: nextProps.topProfileData.data,
        });
      }
    }
    return true;
  }

  componentWillUnmount() {
    clearInterval(this.sidebarIntervalId);
  }

  toggleSideBar = () => {
    this.setState({
      activeSieBar: !this.state.activeSieBar,
    });
  };

  handleSignOutHandler = () => {
    this.props.postLogOut();
    this.setState({
      // activeSieBar: false
      loading: true,
    });
  };

  //will remove after ios version is come out
  mobileOsDetect = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      this.setState({
        deviceOs: "Windows Phone",
      });
    }
    if (/android/i.test(userAgent)) {
      this.setState({
        deviceOs: "android",
      });
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.setState({
        deviceOs: "ios",
      });
    }
  };

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;

    const avatar = this.imageImport(
      require.context("../../assets/images/profile/profile-icons", false, /\.(png|jpe?g|svg)$/)
    );
    const navIcon = this.imageImport(
      require.context("../../assets/images/profile/mobile/icons", false, /\.(png|jpe?g|svg)$/)
    );
    // const icon = this.imageImport(
    //   require.context(
    //     "../../assets/images/icons/mobile",
    //     false,
    //     /\.(png|jpe?g|svg)$/
    //   )
    // );
    const img = this.imageImport(require.context("../../assets/images/", false, /\.(png|jpe?g|svg|webp)$/));
    const icons = this.imageImport(
      require.context(
        "../../assets/images/nav",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    
    return (
      <div className={`side-bar-mobile ${window.location.pathname !== "/login" ? "bg-white m-subHeader" : ""}`}>
        {/* {this.state.loading && <LoadingPage />} */}
        <div className="sb-toggle-btn" onClick={this.toggleSideBar}>
          <Icon icon="ph:squares-four-fill" />
          {/* {(() => {
            if (!this.state.msgLoading) {
              if (this.state.unreadMsgCnt > 0) {
                return <span className="notify-red-dot" />;
              }
            }
          })()} */}
        </div>
        {window.location.pathname === "/dashboard" && <h6>{t('sidebar.dashboard')}</h6>}
        {/* <NavLink to={{ pathname: "/" }} className="sb-logo">
        <img className="w-100" src={img["x33-logo.png"]} alt="x33-logo" />
        </NavLink> */}
        <div className={`sb-menu pb-3 ${this.state.activeSieBar ? "open" : ""} ${window.location.pathname !== "/dashboard" && "w-bg"}`}>
          {/* <NavLink to={{ pathname:"/" }}><img className="sb-banner" src={img["side-bar-banner.jpg"]} alt="banner" /></NavLink> */}          
          {this.state.login ? (
            <>
              <NavLink to={{ pathname: "/personal-details" }}>
                <div className="pi-m-info">
                  <div role="button" className="user-profile-container">
                    <img
                      className="user-profile-img"
                      src={
                        this.state.topProfileData &&
                        this.state.topProfileData.topProfile &&
                        this.state.topProfileData.topProfile.profile_picture
                          ? this.state.topProfileData.topProfile.profile_picture
                          : avatar["male-7.jpg"]
                      }
                      alt="profile img"
                    />
                  </div>
                  <div className="user-info">
                    <p className="us-name pe-2">{this.props.currentUser.data.username ? this.props.currentUser.data.username : this.state.username}</p>
                    {/* <p className="vip-icon">
                      {t("vip.vip")}
                      {this.props.currentUser.data.user_group_level}
                    </p> */}
                  </div>
                  <Icon icon="uil:angle-right" />
                </div>
              </NavLink>
              <ul className="sb-list navbar-nav">
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/dashboard" }}>
                    <img src={icons["dashboard.svg"]} alt="dashboard" />
                    <p>{t('sidebar.dashboard')}</p>
                  </NavLink>
                </li>
                <h6>{t('sidebar.member-detail')}</h6>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/management" }}>
                    <img src={icons["management.svg"]} alt="management" />
                    <p>{t('sidebar.management')}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/betting-history" }}>
                    <img src={icons["betting-history.svg"]} alt="betting-history" />
                    <p>{t('sidebar.betting-history')}</p>
                  </NavLink>
                </li>
                <h6>{t('sidebar.agent-details')}</h6>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/downline-agent" }}>
                    <img src={icons["management.svg"]} alt="downline-agents" />
                    <p>{t('sidebar.downline-agents')}</p>
                  </NavLink>
                </li>
                <h6>{t('sidebar.financial-center')}</h6>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/my-wallet" }}>
                    <img src={icons['wallet.svg']} alt="wallet" />
                    <p>{t('sidebar.my-wallet')}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/withdrawal" }}>
                    <img src={icons["withdrawal.svg"]} alt="withdrawal" />
                    <p>{t('sidebar.withdraw')}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/delegate-deposit" }}>
                    <img src={icons["delegate-deposit.svg"]} alt="delegate-deposit" />
                    <p>{t('sidebar.delegate-deposit')}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/deposit" }}>
                    <img src={icons["deposit.svg"]} alt="deposit" />
                    <p>{t('sidebar.deposit')}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/financial-report" }}>
                    <img src={icons["financial-report.svg"]} alt="financial-report" />
                    <p>{t("sidebar.financial-report")}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/commission-report" }}>
                    <img src={icons["commision-report.svg"]} alt="commission-report" />
                    <p>{t('sidebar.commission-report')}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/transaction-report" }}>
                    <img src={icons["transaction-report.svg"]} alt="transaction-report" />
                    <p>{t('sidebar.transaction-report')}</p>
                  </NavLink>
                </li>
                <h6>{t('sidebar.promotion-center')}</h6>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/promote-link" }}>
                    <img src={icons["promote-link.svg"]} alt="promote-link" />
                    <p>{t('sidebar.promote-link')}</p>
                  </NavLink>
                </li>
                <h6>{t('sidebar.personal-center')}</h6>
                {this.state.login && (
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/message-center" }}>
                    <img src={icons["message-center.svg"]} alt="message-center" />
                    <p>{t('sidebar.message-center')}</p>
                    <div className="badge">
                      {(() => {
                        if (!this.state.msgLoading) {
                          if (this.state.unreadMsgCnt > 0) {
                            return this.state.unreadMsgCnt;
                          } else {
                            return null;
                          }
                        }
                      })()}
                    </div>
                  </NavLink>
                </li>
                )}
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/commision-illustrate" }}>
                    <img src={icons["commision-illustrate.svg"]} alt="commision-illustrate" />
                    <p>{t('sidebar.commission-illustrate')}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={{ pathname: "/contact-us" }}>
                    <img src={icons["contact-us.svg"]} alt="contact-us" />
                    <p>{t('sidebar.contact-us')}</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" to={{ pathname: "/region-language" }}>
                      <img src={icons["region-language.svg"]} alt="region language" />
                      <p>{t('footer.region-language')}</p>
                    </NavLink>
                  </li>           
              </ul>
              <div className="sb-btn gap-3">
                <button className="btn btn-gradient-blue hm-5" onClick={this.handleSignOutHandler}>
                  {t("page-header.logout")}
                </button>
              </div>            
            </>
          ) : (
            <>
              <div className="sb-banner">
                {/* <img src={img["x33-logo.png"]} alt="x33-logo" /> */}
              </div>
              <div className="d-flex flex-column justify-content-between">
                <ul className="sb-list navbar-nav">
                  <li className="nav-item">
                    <NavLink className="nav-link gap-3" to={{ pathname: "/" }}>
                      <img src={icons["dashboard.svg"]} alt="dashboard" />
                      <p>{t('profile-sidebar.home')}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link gap-3" to={{ pathname: "/commission-plan" }}>
                      <img src={icons["commission-plan.svg"]} alt="management" />
                      <p>{t('commission-plan.commission-plan')}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link gap-3" to={{ pathname: "/products" }}>
                      <img src={icons["products.svg"]} alt="betting-history" />
                      <p>{t('info-centre.products')}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link gap-3" to={{ pathname: "/terms-and-conditions" }}>
                      <img src={icons['terms-conditions.svg']} alt="wallet" />
                      <p>{t('referral.terms-and-conditions')}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link gap-3" to={{ pathname: "/contact" }}>
                      <img src={icons["contact.svg"]} alt="withdrawal" />
                      <p>{t('contact-us.contact-us')}</p>
                    </NavLink>
                  </li>           
                  <li className="nav-item">
                    <NavLink className="nav-link gap-3" to={{ pathname: "/region-language" }}>
                      <img src={icons["region-language.svg"]} alt="region language" />
                      <p>{t('footer.region-language')}</p>
                    </NavLink>
                  </li>           
                </ul>
                <div className="sb-btn" style={{ color: "white"}} >
                  <NavLink className="btn btn-gradient-blue hm-5" to={{ pathname: "/login" }}>
                    {t("page-header.login")}/{t("page-header.register")}
                  </NavLink>
                </div>   
              </div>    
            </>
          )}
        </div>
        <div className="overlay" onClick={this.toggleSideBar}></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;

  return {
    currentUser: state.currentUser,
    logout_data: auth.logout_data,
    unreadMessagesCnt: state.inbox.count_unread_inbox_alert_data,
    featured_promos_data: state.home.featured_promos_data,
    topProfileData: state.profile.top_profile_data,
    login_data: auth.login_data,
  };
};

const mapDispatchToProps = {
  getGameVendorList,
  postLogOut,
  getCountUnreadInboxAlert,
  getFeaturedPromotion,
  getTopProfile,
  postLogin,
  getUserData,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withNamespaces("translation")(MobileSidebar)));
